// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__KcJdg","paymentWrapper":"styles_paymentWrapper__is7Wo"};